import { alpha, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  savedBirthCard: {
    border: '1px solid ' + alpha(theme.palette.primary.main, 0.5),
    borderRadius: 8,
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },

  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8
  },

  cardHeaderActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },

  birthBadge: {
    borderRadius: 5,
    padding: theme.app.spacing.sm,
    fontSize: theme.app.typography.label.fontSize,
    fontWeight: 500,
    color: theme.app.colors.text.light,
    backgroundColor: theme.palette.primary.main
  },

  genderIcon: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      width: 24,
      height: 24
    }
  },

  removeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.main,
    transition: 'opacity 0.2s',

    '&:hover': {
      opacity: 0.7
    },

    '& svg': {
      width: 24,
      height: 24
    }
  },

  cardRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },

  animalName: {
    fontSize: theme.app.typography.body.fontSize,
    fontWeight: 600,
    color: theme.app.colors.text.primary
  },

  icon: {
    width: 24,
    height: 20,
    flexShrink: 0
  },

  infoLabel: {
    fontSize: theme.app.typography.label.fontSize,
    color: theme.app.colors.text.secondary,
    fontWeight: 500
  },

  infoText: {
    fontSize: theme.app.typography.label.fontSize,
    color: theme.app.colors.text.primary
  }
}))
